import type { ToOptions } from "@tanstack/react-router";

import { type ButtonProps, buttonVariants } from "@/components/ui/button";
import {
  Link as RACLink,
  type LinkProps as RACLinkProps,
} from "@/components/ui/link";
import { cn } from "@/components/ui/utils";

type LinkProps = {
  asButton?: boolean;
  className?: string;
  target?: string;
  rel?: string;
  ref?: React.Ref<HTMLAnchorElement>;
  children: RACLinkProps["children"];
  onPress?: RACLinkProps["onPress"];
} & ToOptions &
  ButtonProps;

export function Link({
  asButton,
  className,
  size,
  variant,
  ref,
  target,
  rel,
  onPress,
  children,
  ...toProps
}: LinkProps) {
  const classnames = asButton
    ? buttonVariants({ variant, size, className })
    : "";
  return (
    <RACLink
      href={toProps}
      ref={ref}
      className={cn(classnames, className)}
      target={target}
      rel={rel}
      onPress={onPress}
      // biome-ignore lint/correctness/noChildrenProp: must do
      children={children}
    />
  );
}
